// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__2-Zux","choiceBoxes":"toolbarselects_choiceBoxes__2j_eJ","simpleField":"toolbarselects_simpleField__aEkjg"};